(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('exportableService',exportableService);

    exportableService.$inject = ['$http', 'CONFIG','messageService'];

    function exportableService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '/exportable-reports';

        var service = {
            getSalesBookXlsx: getSalesBookXlsx,
            getReportAttDetailedXlsxDownload: getReportAttDetailedXlsxDownload,
            getReportCargoXlsxDownload: getReportCargoXlsxDownload,
            getReportLuggageXlsxDownload: getReportLuggageXlsxDownload,
            getReportPassageXlsxDownload: getReportPassageXlsxDownload,
            getReportsProductionXlsxDownload: getReportsProductionXlsxDownload,
            getReportsSsrXlsxDownload: getReportsSsrXlsxDownload,
            getReportsUnusedTicketXlsxDownload: getReportsUnusedTicketXlsxDownload
        };

        return service;

        function getSalesBookXlsx(economicActivityId, year, month) {
            return $http.get(urlBase + '/sales-invoice/download/xlsx' + '?economicActivityId='+economicActivityId + '&year=' + year + '&month=' + month , {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getReportAttDetailedXlsxDownload(fromDate, toDate) {
            return $http.get(urlBase + '/att-detailed/download/xlsx' + '?fromDate='+fromDate + '&toDate=' + toDate, {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getReportCargoXlsxDownload(fromDate, toDate) {
            return $http.get(urlBase + '/consolidated-cargo/download/xlsx' + '?fromDate='+fromDate + '&toDate=' + toDate, {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getReportLuggageXlsxDownload(fromDate, toDate) {
            return $http.get(urlBase + '/consolidated-luggage/download/xlsx' + '?fromDate='+fromDate + '&toDate=' + toDate, {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getReportPassageXlsxDownload(fromDate, toDate) {
            return $http.get(urlBase + '/consolidated-passage/download/xlsx' + '?fromDate='+fromDate + '&toDate=' + toDate, {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getReportsProductionXlsxDownload(fromDate, toDate) {
            return $http.get(urlBase + '/consolidated-production/download/xlsx' + '?fromDate='+fromDate + '&toDate=' + toDate, {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getReportsSsrXlsxDownload(fromDate, toDate) {
            return $http.get(urlBase + '/consolidated-ssr/download/xlsx' + '?fromDate='+fromDate + '&toDate=' + toDate, {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getReportsUnusedTicketXlsxDownload(fromDate, toDate) {
            return $http.get(urlBase + '/unused-ticket/download/xlsx' + '?fromDate='+fromDate + '&toDate=' + toDate, {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }
    }
})();
